export enum InternalServerErrorConstants {
  ERROR = 'ERROR',
  ERROR_500_HEADER_TEXT = 'ERROR_500_HEADER_TEXT',
  ERROR_500_SUBHEADER_TEXT = 'ERROR_500_SUBHEADER_TEXT',
  ERROR_500_CONTENT_LINE_1 = 'ERROR_500_CONTENT_LINE_1',
  ERROR_500_CONTENT_LINE_2 = 'ERROR_500_CONTENT_LINE_2',
  REFRESH = 'REFRESH',
}
